module.exports = __webpack_public_path__ + "static/media/icon-pocket.ffc9822d.svg";